module.exports = __webpack_public_path__ + "static/mmg-logo-157fbda8152d16f0695f58062623da2b.png";